import React, { lazy, useEffect } from 'react'
import { decryptUrlParam, encryptUrlParam } from '../../shared/helpers/urlHelpers'
import { useModals } from '../../shared/hooks/useModals'
import useSearchParams from '../../shared/hooks/useSearchParams'
import DelayUnmount from '../DelayUnmount'
const ModalDetailOpportunity = lazy(() => import('../ModalDetailOpportunity/ModalDetailOpportunity'))

function OpportunityModals() {
    const { modalState, closeModal, showModal } = useModals()
    const { getParam, setParam, resetParam } = useSearchParams();

    useEffect(() => {
        if (getParam('jobs-detail')) {
            const dekripUrl = decryptUrlParam(getParam('jobs-detail'))
            showModal("detailOpportunity", { oppId: +dekripUrl });
        }
        if (modalState.detailOpportunity.show) {
            const enkripsiurl = encryptUrlParam(modalState.detailOpportunity.data?.oppId)
            setParam('jobs-detail', enkripsiurl);
        }
    }, [modalState.detailOpportunity.show])

    return (
        <React.Fragment>
            <DelayUnmount mount={modalState.detailOpportunity.show}>
                <ModalDetailOpportunity
                    open={modalState?.detailOpportunity?.show}
                    handleClose={() => {
                        closeModal("detailOpportunity")
                        resetParam()
                    }}
                    opportunityId={modalState?.detailOpportunity?.data?.oppId}
                />
            </DelayUnmount>
        </React.Fragment>
    )
}

export default OpportunityModals